/* eslint-disable no-restricted-syntax */
/* eslint-disable complexity */
export function collectEdgePoints(ctx: OffscreenCanvasRenderingContext2D): { x: number; y: number }[] {
    const { width, height } = ctx.canvas;
    const imageData = ctx.getImageData(0, 0, width, height);
    const data = new Uint8ClampedArray(imageData.data);

    const points: { x: number; y: number }[] = [];

    for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
            const index = ((y * width) + x) * 4;
            const r = data[index];
            const g = data[index + 1];
            const b = data[index + 2];

            if (r === 255 && g === 0 && b === 0) {
                // 检查是否为边缘点
                let isEdgePoint = false;

                // 定义四个方向的偏移量
                const directions = [
                    [0, -1], // 上
                    [1, 0], // 右
                    [0, 1], // 下
                    [-1, 0], // 左
                ];

                for (const [dx, dy] of directions) {
                    const nx = x + dx;
                    const ny = y + dy;

                    if (nx >= 0 && nx < width && ny >= 0 && ny < height) {
                        const neighborIndex = ((ny * width) + nx) * 4;
                        if (data[neighborIndex + 3] === 0) {
                            // 检查 alpha 通道值是否为透明
                            isEdgePoint = true;
                            break;
                        }
                    } else {
                        // 如果邻居在图像边界之外，则也认为是边缘点
                        isEdgePoint = true;
                        break;
                    }
                }

                if (isEdgePoint) {
                    points.push({ x, y });
                }
            }
        }
    }

    return points;
}
